import { render, staticRenderFns } from "./ExpertsRegi.vue?vue&type=template&id=35825ac3&"
import script from "./ExpertsRegi.vue?vue&type=script&lang=js&"
export * from "./ExpertsRegi.vue?vue&type=script&lang=js&"
import style0 from "./ExpertsRegi.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports